var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:"icon",staticClass:"icon",class:`icon--${_vm.iconName}`,style:(_vm.cssVars),attrs:{"width":_vm.width,"height":_vm.height,"aria-hidden":"true"},on:{"mouseenter":_vm.getHoverIcon,"mouseleave":_vm.getDefaultIcon}},[_c('use',{attrs:{"href":_vm.svgLink}})])
}
var staticRenderFns = []

export { render, staticRenderFns }